import {EditElementModal} from "../EditElementModal";
import {FaIcon} from "../FaIcon";
import React from "react";
import {CampaignsNotAssignedForm} from "./CampaignsNotAssignedForm";
import { withTranslation } from 'react-i18next';

class CampaignNotAssignedModalComponent extends EditElementModal {
    renderModalForm() {
        return <CampaignsNotAssignedForm closeModal={this.toggle}
                                         onModified={this.handleFormSubmitted}
                                         businessUnitId={this.props.businessUnitId}
                                         clientName={this.props.clientName}/>
    }

    renderButton() {
        return <button className="edit-button" style={{color:"red"}} onClick={this.toggle}><FaIcon iconName={"eye"}/></button>;
    }

    renderModalHeaderText() {
        const { t } = this.props;
        return t('modal.client_campaigns_not_assigned');
    }
}

export const CampaignNotAssignedModal = withTranslation()(CampaignNotAssignedModalComponent);
